import Supplier from 'lib/Core/Backend/Controllers/Supplier';
import React, { useMemo, useState } from 'react';
import Papa from 'papaparse';
import {Row, Col, FormGroup, CustomInput, Popover, PopoverBody} from 'reactstrap';

const GiftCardsFileForm = ({purchaseOrder, openAlert, setFile, setFileInfo, token}) => {
  const supplierCtl = useMemo(() => new Supplier(token),[token]);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const matchLayout = (layout) => {
    if(layout.headerPresent){
      return Papa.parse(document.getElementById('csvLayoutFile').files[0],
        {
          download: true,
          header: true,
          complete: (result) => {
            return layout.fields.every(field => field.sourceName === result.meta.fields[field.sourceIndex]);
          }
        }
      );
    } else {
      return Papa.parse(document.getElementById('csvLayoutFile').files[0],
        {
          download: true,
          header: true,
          complete: (result) => {
            return layout.fields.length >= result.meta.fields.length;
          }
        }
      );
    }
  }

  const validateFile = (e) => {
    e.preventDefault();
    if(document.getElementById('giftCardsFile').files[0]){
      supplierCtl.layout(purchaseOrder.id, (data) => {
        if(data && !data.error) {
          if(data.some(matchLayout)){
            setFile(document.getElementById('giftCardsFile').files[0]);
            setFileInfo({
              supplierId: purchaseOrder.purchaseSourceId,
              layoutId: data.find(matchLayout).id
            });
          } else {
            setPopoverOpen(true);
          }
        } else {
          openAlert(data.error);
        }
      });
    }
  }

  return (
    <>
      <Row className="justify-content-center mt-4">
          <Col md={10}>
            <legend>
                Upload .csv file.
            </legend>


              
             <FormGroup tag="fieldset">
              <CustomInput id="giftCardsFile" type="file" name="type" label="choose file..." accept=".csv" onChange={validateFile} />
              <Popover placement="bottom" isOpen={popoverOpen} target="giftCardsFile">
								<PopoverBody><i className="fas fa-exclamation-triangle text-warning"/>File does not match layout</PopoverBody>
							</Popover>
            </FormGroup>
          </Col>
      </Row>
    </>
  );
}
 
export default GiftCardsFileForm;